export default "__VITE_ASSET__ZRydEA9H__"